import { NAME } from './constants';

export const FETCH_REQUEST = `${NAME}/FETCH_REQUEST`;
export const FETCH_ON_SUCCESS = `${NAME}/FETCH_ON_SUCCESS`;
export const FETCH_ON_ERROR = `${NAME}/FETCH_ON_ERROR`;
export const FETCH_UPDATE_METADATA = `${NAME}/FETCH_UPDATE_METADATA`;
export const FETCH_CLEAR = `${NAME}/FETCH_CLEAR`;
